function createPlayOverlayElement() {
  const overlay = document.createElement("div");
  const playSVGString = `<div class="play-button">
  <svg
    focusable="false"
    class="icon icon-media-play"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    style="enable-background:new 0 0 24 24;"
    xml:space="preserve"
  >
    <path fill="currentColor" d="M3,22V2l18,10L3,22z"/>
  </svg>
</div>`;

  overlay.classList.add("obj-es-play__overlay");
  overlay.innerHTML = playSVGString;

  return overlay;
}

/**
 * Applies overlay with a play SVG on the Essential Grid Gallery app list items.
 *
 * @param {string} sectionSelector - selector string for the section id.
 */
function applyCustomPlayOverlays(sectionSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const essentialsVideoApp = section.querySelector(
    ".eg_grid_gallery_app_section",
  );
  if (!essentialsVideoApp) return;

  const esListItems = essentialsVideoApp.querySelectorAll("li");
  if (!esListItems.length) return;

  esListItems.forEach((item) => {
    const cover = item.querySelector(".esg-media-cover-wrapper");
    cover.appendChild(createPlayOverlayElement());
  });
}
